import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconEngagement from './nav-icon-engagement.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconEngagement {...validProps} />;
}
SvgComponent.iconName = 'navIconEngagement';

/**
 * @deprecated This is a legacy icon
 */
export const NavIconEngagementIcon = svgIconWrapper(SvgComponent);
